import { controls } from "../../controls";

const rp1211 = {
  label: "Pay Register",
  pageLabel: "Pay Register",
  starting: true,
  url: "rp1211",

  pageType: "history",
  filter: [

    ...controls.displayText({ tab: "filter", label: "Month", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "month", width: "col-sm-2", placeHolder: "month" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Year", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "year", width: "col-sm-2", placeHolder: "year" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),



    ...controls.displayText({ tab: "filter", label: "Grade", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "grade", width: "col-sm-2", placeHolder: "Grade" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "Modal", label: "Designation", width: "col-sm-2" }),
    ...controls.text({ tab: "Modal", name: "designation", width: "col-sm-2", placeHolder: "Designation" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "Modal", label: "Employeee Code", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "Modal", name: "employee_code", width: "col-sm-2", placeHolder: "employee code" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "From Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "from_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "To Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "to_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Pay Type", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "pay_type", width: "col-sm-2", placeHolder: "Pay Type" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Sort By", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "sort_by", width: "col-sm-2", placeHolder: "Sort By" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.checkBox({ tab: "filter", label: "Group Wise", name: "Group Wise", width: "col-sm-2" }),

    ...controls.checkBox({ tab: "filter", label: "Print Grade", name: "Print Grade", width: "col-sm-2" }),

    ...controls.checkBox({ tab: "filter", label: "Print Designation", name: "Print Designation", width: "col-sm-2" }),

    ...controls.checkBox({ tab: "filter", label: "Print Department", name: "Print Department", width: "col-sm-2" }),

    ...controls.checkBox({ tab: "filter", label: "Print Branch", name: "Print Branch", width: "col-sm-2" }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Pay Register",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30
      },
      {
        Header: "Branch",
        accessor: "branch"

      },

      {
        Header: "Designation",
        accessor: "designation",

      },

      {
        Header: "Grade",
        accessor: "grade",

      },
      {
        Header: "Department",
        accessor: "department",

      },

      {
        Header: "Code",
        accessor: "code",

      },

      {
        Header: "Name",
        accessor: "name",

      },

      {
        Header: "Pay Type",
        accessor: "pay_type",

      },

      {
        Header: "Month Year",
        accessor: "month_year",

      },




    ]
  }
};

export default rp1211;